<template>
  <table>
     <tr class="iconDiv">
        <td width=40 class="idt">{{bug.id}}</td>
        <td width=50 class="clipImg"><img :src="bug.img" alt="">
        </td>
        <td  width=180 class="idtd iname">{{bug.cname}}</td>
        <td  class="idir iprice" width=180>{{format(bug.price)}} 铃钱</td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td class="idtd2">刷新点：</td>
        <td  class="idir ilocation">{{bug.clocation}}</td>
    </tr>
    <tr v-show="banq==1" v-for="(month,index) in bug.cseasonn" v-bind:key="'n'+bug.id+index">
        <td></td>
        <td></td>
        <td v-if="index==0" class="idtd2">月份[北半球]：</td>
        <td v-if="index!=0" class="idtd2"></td>
        <td  class="idir">{{month}}</td>
    </tr>
    <tr v-show="banq==2" v-for="(month,index) in bug.cseasons" v-bind:key="'s'+bug.id+index">
        <td></td>
        <td></td>
        <td v-if="index==0" class="idtd2">月份[南半球]：</td>
        <td v-if="index!=0" class="idtd2"></td>
        <td  class="idir">{{month}}</td>
    </tr>
    <tr v-for="(time,index) in bug.ctimes" v-bind:key="'ss'+bug.id+index" class="iconDiv">
        <td></td>
        <td></td>
        <td v-if="index==0" class="idtd2">时间：</td>
        <td v-if="index!=0" class="idtd2"></td>
        <td class="idir">{{time}}</td>
    </tr>
    <tr v-if="bug.size.length > 0">
        <td></td>
        <td></td>
        <td class="idtd2">备注：</td>
        <td  class="idir imark">{{bug.size}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'Bug',
  props: ['bug', 'banq'],
  methods: {
    format: function (e) {
      let x = parseInt(e) + ''
      let t = x.split('')
      let r = ''
      for (let index = t.length - 1; index >= 0; index--) {
        const element = t[index]
        r = element + r
        if ((t.length - index) % 3 === 0 && index !== 0) {
          r = ',' + r
        }
      }
      return r
    }
  }
}
</script>

<style scoped>
.iconDiv img{
  height: 50px;
  width: auto;
  margin: 0px;
  padding: 0px;
}
.clipImg {
  margin-left: 20px;
  border-radius:50px;
  /* border: 2px solid #e4007e; */
  padding: 0px;
  margin: 0px;
  overflow: auto;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
}
.iconDiv {
  margin-bottom: 2px;
}
table {
  margin-top: 10px;
  padding-left: 20px;
  text-align: center;
}
.idtd{
  font-size: 16px;
  font-weight: 800;
  text-align: right;
}
.idtd2{
  font-weight: 500;
  text-align: right;
}
.idir{
  text-align: left;
}
.idt{
  font-size: 18px;
  font-weight: 800;
  text-align: left;
}
.imark {
  color: #ff1444;
}
.iprice {
  color: #FF9500;
  font-family: DINCondensed-Bold;
font-size: 18px;
letter-spacing: 1.33px;
}
.ilocation {
  font-weight: 800;
  color: RGB(45, 188, 173);
}
.iname {
  text-align: center;
  font-size: 18px;
  color: black;
  /* color: RGB(42, 183, 123); */
}
.iname::after {
  content: "";
  background-color: RGBA(45, 188, 173, 0.3);
  height: 10px;
  width: 30px;
  transform: translate(-30px,15px);
  position: absolute;
  z-index: -10;
}
</style>



// WEBPACK FOOTER //
// src/components/Bug.vue